import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { PRIMARY_OUTLET, Router, UrlSegment, UrlSegmentGroup, UrlTree } from '@angular/router';
import { Constants } from '../../utils/constants';

@Component({
  selector: 'app-display-asset',
  templateUrl: './display-asset.component.html',
  styleUrls: ['./display-asset.component.css']
})
export class DisplayAssetComponent implements OnInit {

  @Input() type: number;
  @Input() thumbnail: string;
  @Input() resourceURL: string;
  
  public TYPES = Constants.RESOURCE_TYPE;
  url: string | SafeUrl;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router) {
  }

  ngOnInit(): void {

  }

  getVideoUrl() {
    if (this.type == this.TYPES.VIDEO) {
      let videoId = this.resourceURL.split('/').pop();
      this.resourceURL = "https://player.vimeo.com/video/" + videoId;
    }
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.resourceURL);
    return this.url;
  }
  
  openLink() {
    let url: string = '';
    if (!/^http[s]?:\/\//.test(this.resourceURL)) {
        url += 'http://';
    }

    url += this.resourceURL;
    window.open(url, '_blank');
  }

  isValidUrl() {
    //if (/^([\\da-z.-]+)\\.([a-z.]{2,6})[\/\\w .-]*/.test(this.url.toString())) {
      return true;
    /*}
    return false;*/
  }

}
